import React, { createContext, useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import {
    GetSalesInvoice,
    postVehicleJobsCompleteJob_NoRecharge,
    SalesInvoice_ChangePerformaToInvoice,
    SalesInvoiceAddHeaderLabourPart
} from '../../../../../../Core/Services/InternalUser/JOB/jobItemsService';

const SellerInvoiceContext = createContext();

export const useSellerInvoice = () => useContext(SellerInvoiceContext);

export const SellerInvoiceProvider = ({ children, props }) => {
    const [state, setState] = useState({
        invoiceLines: [],
        vatRate: [],
        scheduleDocs: [],
        jobDocs: [],
        vehicleDetails: [],
        partsDetails: [],
        purchaseInvoiceDate: moment().format('YYYY-MM-DD'),
        purchaseInvoiceDateDue: '',
        purchaseNominalCode: '',
        errors: {},
        invoiceItemVATRateID: { id: 2, name: '20.0% S', vatRatePercent: 20 },
        iSDropDownUpdate: false,
        isRechargeLine: false
    });

    const [emailTemp, setEmailTemp] = useState({
        authorityEmail: '',
        authoritySub: '',
        authorityBody: '',
        emaileventdocument: '',
        sendAuthorityEmail: false
    });

    const [btnLoader, setBtnLoader] = useState(false);
    const [showMail, setShowMail] = useState(false);

    const { showToastSuccess, showToastError } = useToast();

    useEffect(() => {
        if (state.invoiceLines.length > 0 && props.showPerformaInvoice) {
            props.showPerformaInvoice(true);
        }
    }, [state.invoiceLines]);

    useEffect(() => {
        if (props.showOpenLine) {
            props.showOpenLine(state.vehicleDetails[0]);
        }
    }, [state.vehicleDetails]);

    const handleMail = () => {
        setShowMail(!showMail);
    };

    const getEmailValues = (obj) => {
        setEmailTemp({ ...obj });
        handelandEmailSubmit(obj);
        handleMail();
    };

    useEffect(() => {
        let fetch = async () => {
            let res1 = await GetSalesInvoice(props.scheduleJobID);
            if (res1.success) {
                setState((st) => ({
                    ...st,
                    vatRate: res1.data.vatRate,
                    scheduleDocs: [...res1.data.scheduleDocs],
                    jobDocs: [...res1.data.jobDocs],
                    vehicleDetails: res1.data?.vehicleDetails || [],
                    invoiceLines: res1.data.invoiceLines.map((m) => ({ ...m, invoiceItemVATRateID: null, invoiceItemVAT: null, isSelected: true })) || [],
                    partsDetails: res1.data.partsDetails.map((m) => ({ ...m, invoiceItemVATRateID: null, invoiceItemVAT: null, isSelected: true })),
                    iSDropDownUpdate: true,
                    isRechargeLine: res1.data.invoiceLines.length > 0 ? true : false
                }));
                if (props.stopLoader) props.stopLoader();
            }
        };
        fetch();
    }, [props.scheduleJobID]);

    const inputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'purchaseInvoiceDate') {
            let dueDate = moment(value).add(state.vehicleDetails[0]?.paymentDays || 0, 'd');
            setState((st) => ({ ...st, [name]: value, purchaseInvoiceDateDue: moment(dueDate).format('YYYY-MM-DD') }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const percentage = (num, per) => {
        return (num / 100) * per;
    };

    const getFixedDigit = (val) => {
        return val ? val.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0;
    };

    const onInvoiceItemChange = (ev, val) => {
        if (val) {
            let invoiceLines = state.invoiceLines.map((x) => ({
                ...x,
                invoiceItemVAT: getFixedDigit(percentage(x.labourExVAT, val.vatRatePercent)),
                invoiceItemVATRateID: val
            }));
            let changedArray = state.partsDetails.map((x) => ({
                ...x,
                invoiceItemVAT: getFixedDigit(percentage(x.total, val.vatRatePercent)),
                invoiceItemVATRateID: val
            }));
            setState((state) => {
                const nst = { ...state, invoiceItemVATRateID: val, partsDetails: changedArray, invoiceLines: invoiceLines };
                return nst;
            });
        }
    };

    useEffect(() => {
        if (state.invoiceLines.length > 0) {
            let invoiceLines = state.invoiceLines.map((x) => ({
                ...x,
                invoiceItemVAT: getFixedDigit(percentage(x.labourExVAT, state.invoiceItemVATRateID.vatRatePercent)),
                invoiceItemVATRateID: state.invoiceItemVATRateID
            }));
            setState((state) => {
                const nst = { ...state, invoiceLines: invoiceLines };
                return nst;
            });
        }
        if (state.partsDetails.length > 0) {
            let changedArray = state.partsDetails.map((x) => ({
                ...x,
                invoiceItemVAT: getFixedDigit(percentage(x.total, state.invoiceItemVATRateID.vatRatePercent)),
                invoiceItemVATRateID: state.invoiceItemVATRateID
            }));
            setState((state) => {
                const nst = { ...state, partsDetails: changedArray };
                return nst;
            });
        }
    }, [state.iSDropDownUpdate, state.invoiceItemVATRateID]);

    const invoiceLinesCheckField = (num, i) => (e, val) => {
        const { name, type, value } = e.target;
        let changedArray = [...state.invoiceLines];
        let objIndex = state.invoiceLines.findIndex((x) => x.itemID === i);
        if (type?.toLowerCase() === 'text' || type.toLowerCase() === 'number') {
            changedArray[objIndex][name] = value;
            if (name === 'labourHours' || name === 'labourRate' || name === 'labourDiscount') {
                let data = changedArray[objIndex];
                const total1 = (data['labourHours'] * data['labourRate'] * (100 - data['labourDiscount'] || 0)) / 100;
                data['labourExVAT'] = getFixedDigit(total1);
            }
        } else if (val) {
            changedArray[objIndex]['invoiceItemVATRateID'] = val;
            changedArray[objIndex]['invoiceItemVAT'] = getFixedDigit(percentage(num, val.vatRatePercent));
        }
        setState((state) => {
            const nst = { ...state, invoiceLines: changedArray };
            return nst;
        });
    };

    const invoiceLinesCheckBox = (i) => (e) => {
        const { name, checked } = e.target;
        let changedArray = [...state.invoiceLines];
        let objIndex = state.invoiceLines.findIndex((x) => x.itemID === i);
        changedArray[objIndex][name] = checked;
        setState((state) => {
            const nst = { ...state, invoiceLines: changedArray };
            return nst;
        });
    };

    const PartSelectChange = (num, id) => (ev, val) => {
        let changedArray = [...state.partsDetails];
        let objIndex = state.partsDetails.findIndex((x) => x.partID === id);
        if (val) {
            let calPercentage = percentage(num, val.vatRatePercent);
            changedArray[objIndex]['invoiceItemVATRateID'] = val;
            changedArray[objIndex]['invoiceItemVAT'] = getFixedDigit(calPercentage);
            setState((state) => {
                const nst = { ...state, partsDetails: changedArray };
                return nst;
            });
        }
    };

    const handleFields = (i) => (e) => {
        const { name, value, checked, type } = e.target;
        let changedArray = [...state.partsDetails];
        let objIndex = state.partsDetails.findIndex((x) => x.partID === i);
        if (type.toLowerCase() === 'text' || type.toLowerCase() === 'number') {
            changedArray[objIndex][name] = value;
            if (name === 'qty' || name === 'unitPrice' || name === 'discount') {
                let data = changedArray[objIndex];
                const total1 = (data['qty'] * data['unitPrice'] * (100 - data['discount'] || 0)) / 100;
                data['total'] = getFixedDigit(total1);
            }
        } else {
            changedArray[objIndex][name] = checked;
        }

        setState((state) => {
            const nst = { ...state, partsDetails: changedArray };
            return nst;
        });
    };

    const handelandEmailSubmit = async (emailObject) => {
        if (props.salesInvoiceStatus == 'I' && !props.jobCustomerOrderNo) {
            alert('Order number is required');
            return;
        }
        let authorityEmail = '';
        let authoritySub = '';
        let authorityBody = '';
        let emaileventdocument = '';
        let sendAuthorityEmail = false;
        if (emailObject) {
            authorityEmail = emailObject.authorityEmail;
            authoritySub = emailObject.authoritySub;
            authorityBody = emailObject.authorityBody;
            sendAuthorityEmail = emailObject.sendAuthorityEmail;
            emaileventdocument = emailObject.emaileventdocument;
        }
        setBtnLoader(true);
        let salesLabourItems = state.invoiceLines
            .filter((m) => m.isSelected)
            .map((m) => ({
                jobItemID: m.itemID,
                labourVATRateID: m.invoiceItemVATRateID?.id,
                labourHours: m.labourHours,
                labourRate: m.labourRate,
                labourDescription: m.labourDescription,
                labourDiscount: m.labourDiscount,
                labourVATPercent: m.invoiceItemVATRateID?.vatRatePercent,
                labourVATAmount: m.invoiceItemVAT,
                labourCost: m.labourExVAT
            }));
        let salesPartsItems = state.partsDetails
            .filter((m) => m.isSelected)
            .map((m) => ({
                jobItemID: m.jobItemID,
                partNumber: m.partNumber,
                partDescription: m.partDescription,
                partQuantity: m.qty,
                partUnitPrice: m.unitPrice,
                partDiscount: m.discount,
                partVATRateID: m.invoiceItemVATRateID?.id,
                partVATPercent: m.invoiceItemVATRateID?.vatRatePercent,
                partVATAmount: m.invoiceItemVAT
            }));
        let formData = {
            salesLabourItems: salesLabourItems,
            salesPartsItems: salesPartsItems,
            jobCustomerOrderNo: props.jobCustomerOrderNo,
            salesInvoiceDate: state.purchaseInvoiceDate,
            salesInvoiceDateDue: state.purchaseInvoiceDateDue,
            salesInvoiceJobID: props.scheduleJobID,
            jobApprovedOrderNo: props.jobApprovedOrderNo,
            salesInvoiceStatus: props.salesInvoiceStatus,
            sendFiles: state.scheduleDocs
                .filter((m) => m.sendToCustomer)
                .map((q) => ({
                    uniqueFileName: q.uniqueFileName,
                    fileExt: q.fileExt,
                    fileName: q.fileName,
                    scheduleDocID: q.scheduleDocID
                })),
            sendJobFiles: state.jobDocs
                .filter((m) => m.sendToCustomer)
                .map((q) => ({
                    uniqueFileName: q.uniqueFileName,
                    fileExt: q.fileExt,
                    fileName: q.fileName,
                    scheduleDocID: q.scheduleDocID
                })),
            jobCustomerID: props.customerID,
            sendEmailTo: emaileventdocument,
            authorityEmail: authorityEmail,
            authoritySub: authoritySub,
            authorityBody: authorityBody,
            sendAuthorityEmail: sendAuthorityEmail,
            sendOnlyEmail: props.salesInvoiceStatus === 'P' && state.vehicleDetails[0]?.isProforma ? true : false,
            proformaFile: state.vehicleDetails[0]?.proformaFile,
            proformaFileName: state.vehicleDetails[0]?.proformaFileName
        };

        let res = {};
        if (!props.isShowPerformaInvoice) {
            res = await postVehicleJobsCompleteJob_NoRecharge({ jobID: props.scheduleJobID });
        } else if (props.salesInvoiceStatus === 'P') {
            res = await SalesInvoiceAddHeaderLabourPart(formData);
        } else if (props.salesInvoiceStatus === 'I') {
            res = await SalesInvoice_ChangePerformaToInvoice(formData);
        } else {
            showToastError('Something went wrong');
        }
        if (res.success) {
            setBtnLoader(false);
            showToastSuccess(res.data.message);
            if (props.handleSubmitValue) props.handleSubmitValue();
        } else {
            showToastError('error');
        }
        setBtnLoader(false);
    };

    const handelSubmit = async () => {
        if (props.salesInvoiceStatus == 'I' && !props.jobCustomerOrderNo) {
            alert('Order number is required');
            return;
        }
        setBtnLoader(true);
        let salesLabourItems = state.invoiceLines
            .filter((m) => m.isSelected)
            .map((m) => ({
                jobItemID: m.itemID,
                labourVATRateID: m.invoiceItemVATRateID?.id,
                labourHours: m.labourHours,
                labourRate: m.labourRate,
                labourDescription: m.labourDescription,
                labourDiscount: m.labourDiscount,
                labourVATPercent: m.invoiceItemVATRateID?.vatRatePercent,
                labourVATAmount: m.invoiceItemVAT,
                labourCost: m.labourExVAT
            }));
        let salesPartsItems = state.partsDetails
            .filter((m) => m.isSelected)
            .map((m) => ({
                jobItemID: m.jobItemID,
                partNumber: m.partNumber,
                partDescription: m.partDescription,
                partQuantity: m.qty,
                partUnitPrice: m.unitPrice,
                partDiscount: m.discount,
                partVATRateID: m.invoiceItemVATRateID?.id,
                partVATPercent: m.invoiceItemVATRateID?.vatRatePercent,
                partVATAmount: m.invoiceItemVAT
            }));
        let formData = {
            salesLabourItems: salesLabourItems,
            salesPartsItems: salesPartsItems,
            jobCustomerOrderNo: props.jobCustomerOrderNo,
            salesInvoiceDate: state.purchaseInvoiceDate,
            salesInvoiceDateDue: state.purchaseInvoiceDateDue,
            salesInvoiceJobID: props.scheduleJobID,
            jobApprovedOrderNo: props.jobApprovedOrderNo,
            salesInvoiceStatus: props.salesInvoiceStatus,
            sendFiles: state.scheduleDocs
                .filter((m) => m.sendToCustomer)
                .map((q) => ({
                    uniqueFileName: q.uniqueFileName,
                    fileExt: q.fileExt,
                    fileName: q.fileName,
                    scheduleDocID: q.scheduleDocID
                })),
            sendJobFiles: state.jobDocs
                .filter((m) => m.sendToCustomer)
                .map((q) => ({
                    uniqueFileName: q.uniqueFileName,
                    fileExt: q.fileExt,
                    fileName: q.fileName,
                    scheduleDocID: q.scheduleDocID
                })),
            jobCustomerID: props.customerID,
            sendEmailTo: emailTemp.emaileventdocument,
            authorityEmail: emailTemp.authorityEmail,
            authoritySub: emailTemp.authoritySub,
            authorityBody: emailTemp.authorityBody,
            sendAuthorityEmail: emailTemp.sendAuthorityEmail
        };

        let res = {};
        if (!props.isShowPerformaInvoice) {
            res = await postVehicleJobsCompleteJob_NoRecharge({ jobID: props.scheduleJobID });
        } else if (props.salesInvoiceStatus === 'P' || !props.isProformaCreated) {
            res = await SalesInvoiceAddHeaderLabourPart(formData);
        } else if (props.salesInvoiceStatus === 'I') {
            res = await SalesInvoice_ChangePerformaToInvoice(formData);
        } else {
            showToastError('Something went wrong');
        }
        if (res.success) {
            setBtnLoader(false);
            showToastSuccess(res.data.message);
            if (props.handleSubmitValue) props.handleSubmitValue();
        } else {
            showToastError('error');
        }
        setBtnLoader(false);
    };

    const handlescheduleDocsChange = (index) => {
        let docs = [...state.scheduleDocs];
        docs[index].sendToCustomer = !docs[index].sendToCustomer;
        setState((st) => ({
            ...st,
            scheduleDocs: docs
        }));
    };

    const handlejobDocsChange = (index) => {
        let docs = [...state.jobDocs];
        docs[index].sendToCustomer = !docs[index].sendToCustomer;
        setState((st) => ({
            ...st,
            jobDocs: docs
        }));
    };

    const contextValue = {
        state,
        setState,
        emailTemp,
        setEmailTemp,
        btnLoader,
        setBtnLoader,
        showMail,
        setShowMail,
        handleMail,
        getEmailValues,
        inputChange,
        onInvoiceItemChange,
        invoiceLinesCheckField,
        invoiceLinesCheckBox,
        PartSelectChange,
        handleFields,
        handelandEmailSubmit,
        handelSubmit,
        handlescheduleDocsChange,
        handlejobDocsChange,
        props
    };

    return <SellerInvoiceContext.Provider value={contextValue}>{children}</SellerInvoiceContext.Provider>;
};
